import UserActionTypes from "./user.types";

const INITIAL_STATE = {
  currentUser: undefined,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case UserActionTypes.SIGN_OUT:
      return {
        ...state,
        currentUser: undefined,
      };
    default:
      return state;
  }
};

export default userReducer;
